import axios from 'axios'

export default {
  namespaced: true,
  state: {
    notificationAdminProjectGrid: [],
    notificationAdminProjectTypes: [],
    notificationAdminProjectShow: null,
    pageData: null,
    notificationAdminProjectTriggersList: [],
    notificationAdminProjectProjectsList: [],
  },
  mutations: {
    setNotificationAdminProjectGrid(state, payload) {
      state.notificationAdminProjectGrid = payload
    },
    setNotificationAdminProjectTypes(state, payload) {
      state.notificationAdminProjectTypes = payload
    },
    setNotificationAdminProjectShow(state, payload) {
      state.notificationAdminProjectShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setNotificationAdminProjectTriggersList(state, payload) {
      state.notificationAdminProjectTriggersList = payload
    },
    setNotificationAdminProjectProjectsList(state, payload) {
      state.notificationAdminProjectProjectsList = payload
    },
  },
  getters: {
    notificationAdminProjectGrid: (state) => state.notificationAdminProjectGrid,
    notificationAdminProjectShow: (state) => state.notificationAdminProjectShow,
    notificationAdminProjectTriggersList: (state) => {
      let array = []
      for (const [key, value] of Object.entries(state.notificationAdminProjectTriggersList)) {
        array.push({ value: key, text: value })
      }
      return array
    },
    pageData: (state) => state.pageData,
    notificationAdminProjectProjectsList: (state) => state.notificationAdminProjectProjectsList,
  },
  actions: {
    onNotificationAdminProjectGrid({ commit, rootState }, { limit, page, sort, search }) {
      let url = rootState.apiDomain + '/api/admin/notification/project-notification?limit=' + limit + '&page=' + page
      url = url + String(sort ? '&order[]=' + sort.param + ':' + sort.value : '&order[]=created_at:desc')
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({ url, method: 'GET' })
          .then((resp) => {
            commit('setNotificationAdminProjectGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminProjectTriggersList({ commit, rootState }) {
      let url = rootState.apiDomain + '/api/admin/notification/project-notification/triggers'
      return new Promise((resolve, reject) => {
        axios({ url, method: 'GET' })
          .then((resp) => {
            commit('setNotificationAdminProjectTriggersList', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminProjectProjectsList({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/project-notification/projects',
          method: 'GET'
        })
          .then((resp) => {
            commit('setNotificationAdminProjectProjectsList', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminProjectCreate({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        console.log(data)
        axios({
          url: rootState.apiDomain + '/api/admin/notification/project-notification/',
          data,
          method: 'POST'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminProjectUpdate({ rootState }, { id, data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/project-notification/' + id,
          data,
          method: 'PUT'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminProjectDelete({ rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/project-notification/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}